module.exports = __webpack_public_path__ + "static/Insights-e372031c0f348c4dbe0ef84dad38554d.png";